import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IOffer) {
    (function(RetailerOfferName) {
        /**
     * @deprecated
     */ RetailerOfferName["POST_ORDER_INSIDER_ENROLLMENT"] = "POST_ORDER_INSIDER_ENROLLMENT";
        /**
     * @deprecated
     */ RetailerOfferName["POST_ORDER_INSIDER_ENROLLMENT_V2"] = "POST_ORDER_INSIDER_ENROLLMENT_V2";
        RetailerOfferName["OPENING_ORDER_DISCOUNT"] = "OPENING_ORDER_DISCOUNT";
        /**
     * Promotional pricing for monthly billed Insider membership fees when retailers are ineligible for annual billing
     */ RetailerOfferName["INSIDER_SIGNUP_INCENTIVE"] = "INSIDER_SIGNUP_INCENTIVE";
        /**
     * @deprecated
     */ RetailerOfferName["FIRST_ORDER_INCENTIVE"] = "FIRST_ORDER_INCENTIVE";
        /**
     * @deprecated
     */ RetailerOfferName["RE_ENGAGEMENT_INCENTIVE"] = "RE_ENGAGEMENT_INCENTIVE";
        /**
     * @deprecated
     */ RetailerOfferName["FIRST_ORDER_INCENTIVE_V2_100_OFF_MIN_200"] = "FIRST_ORDER_INCENTIVE_V2_100_OFF_MIN_200";
        /**
     * @deprecated
     */ RetailerOfferName["FIRST_ORDER_INCENTIVE_V2_50_PERCENT_OFF"] = "FIRST_ORDER_INCENTIVE_V2_50_PERCENT_OFF";
        RetailerOfferName["CUSTOM_OFFER"] = "CUSTOM_OFFER";
        RetailerOfferName["EUROPEAN_LOCAL_DISCOUNT"] = "EUROPEAN_LOCAL_DISCOUNT";
        /**
     * @deprecated
     */ RetailerOfferName["FIRST_ORDER_INCENTIVE_V2_30_PERCENT_OFF"] = "FIRST_ORDER_INCENTIVE_V2_30_PERCENT_OFF";
        /**
     * @deprecated
     */ RetailerOfferName["FIRST_ORDER_INCENTIVE_V3_CONTROL"] = "FIRST_ORDER_INCENTIVE_V3_CONTROL";
        /**
     * @deprecated
     */ RetailerOfferName["FIRST_ORDER_INCENTIVE_V3_OPTIMIZED_PROMOTION"] = "FIRST_ORDER_INCENTIVE_V3_OPTIMIZED_PROMOTION";
        /**
     * @deprecated
     */ RetailerOfferName["FIRST_ORDER_INCENTIVE_V3_OPTIMIZED_PROMOTION_PLUS"] = "FIRST_ORDER_INCENTIVE_V3_OPTIMIZED_PROMOTION_PLUS";
        /**
     * @deprecated
     */ RetailerOfferName["FD_CREDIT_MARKETPLACE_PIVOT"] = "FD_CREDIT_MARKETPLACE_PIVOT";
        /**
     * @deprecated
     */ RetailerOfferName["PERSONALIZED_FIRST_ORDER_INCENTIVE_V1"] = "PERSONALIZED_FIRST_ORDER_INCENTIVE_V1";
        RetailerOfferName["PERSONALIZED_FIRST_ORDER_INCENTIVE_V1_50_PERCENT"] = "PERSONALIZED_FIRST_ORDER_INCENTIVE_V1_50_PERCENT";
        /**
     * @deprecated
     */ RetailerOfferName["PERSONALIZED_FIRST_ORDER_INCENTIVE_V1_CONTROL"] = "PERSONALIZED_FIRST_ORDER_INCENTIVE_V1_CONTROL";
        RetailerOfferName["FIRST_ORDER_INCENTIVE_AUTO_EXTEND_V1"] = "FIRST_ORDER_INCENTIVE_AUTO_EXTEND_V1";
        RetailerOfferName["GRANT_RETAILER_FREE_SHIPPING_FOR_BRAND"] = "GRANT_RETAILER_FREE_SHIPPING_FOR_BRAND";
        RetailerOfferName["ACH_PROACTIVE_LIMIT_INCREASE"] = "ACH_PROACTIVE_LIMIT_INCREASE";
        RetailerOfferName["FAIRE_DIRECT_MARKETPLACE_DISCOUNT"] = "FAIRE_DIRECT_MARKETPLACE_DISCOUNT";
        /**
     * @deprecated
     */ RetailerOfferName["SHOPIFY_FIRST_ORDER_DISCOUNT"] = "SHOPIFY_FIRST_ORDER_DISCOUNT";
        /**
     * @deprecated
     */ RetailerOfferName["SHOPIFY_NEXT_ORDER_DISCOUNT"] = "SHOPIFY_NEXT_ORDER_DISCOUNT";
        RetailerOfferName["SHOPIFY_FREE_ONE_YEAR_INSIDER_INCENTIVE"] = "SHOPIFY_FREE_ONE_YEAR_INSIDER_INCENTIVE";
        RetailerOfferName["SHOPIFY_PAID_PLAN_ENROLLMENT"] = "SHOPIFY_PAID_PLAN_ENROLLMENT";
        RetailerOfferName["ACH_TERMS_PRE_APPROVAL"] = "ACH_TERMS_PRE_APPROVAL";
        RetailerOfferName["SHOPIFY_FIRST_ORDER_INCENTIVE_OFFER"] = "SHOPIFY_FIRST_ORDER_INCENTIVE_OFFER";
        RetailerOfferName["SHOPIFY_NEXT_ORDER_INCENTIVE_OFFER"] = "SHOPIFY_NEXT_ORDER_INCENTIVE_OFFER";
        /**
     * @deprecated
     */ RetailerOfferName["EVERGREEN_FIRST_ORDER_INCENTIVE_V1"] = "EVERGREEN_FIRST_ORDER_INCENTIVE_V1";
        RetailerOfferName["GENERIC_OFFER"] = "GENERIC_OFFER";
        RetailerOfferName["PROMO_CODE"] = "PROMO_CODE";
        RetailerOfferName["PERSONALIZED_FIRST_ORDER_INCENTIVE_V2_50_PERCENT"] = "PERSONALIZED_FIRST_ORDER_INCENTIVE_V2_50_PERCENT";
        RetailerOfferName["PERSONALIZED_FIRST_ORDER_INCENTIVE_V2_AUTO_EXTEND"] = "PERSONALIZED_FIRST_ORDER_INCENTIVE_V2_AUTO_EXTEND";
        /**
     * @deprecated
     */ RetailerOfferName["EVERGREEN_PERSONALIZED_FIRST_ORDER_INCENTIVE_V2"] = "EVERGREEN_PERSONALIZED_FIRST_ORDER_INCENTIVE_V2";
        RetailerOfferName["EVERGREEN_MARKETPLACE_DISCOUNT"] = "EVERGREEN_MARKETPLACE_DISCOUNT";
        RetailerOfferName["FAIRE_DIRECT_SIGNUP_INCENTIVE"] = "FAIRE_DIRECT_SIGNUP_INCENTIVE";
        /**
     * Replaced by POST_FIRST_CONFIRMED_ORDER_INCENTIVE_DISCOUNT as the name is too long to fit into the offers table
     * @deprecated
     */ RetailerOfferName["POST_FIRST_CONFIRMED_ORDER_DISCOVERY_INCENTIVE_DISCOUNT"] = "POST_FIRST_CONFIRMED_ORDER_DISCOVERY_INCENTIVE_DISCOUNT";
        RetailerOfferName["POST_FIRST_CONFIRMED_ORDER_INCENTIVE_DISCOUNT"] = "POST_FIRST_CONFIRMED_ORDER_INCENTIVE_DISCOUNT";
        /**
     * Reward for using Faire Pay
     */ RetailerOfferName["FAIRE_PAY_REWARD"] = "FAIRE_PAY_REWARD";
        /**
     * Reward for enrolling Faire Pay
     */ RetailerOfferName["FAIRE_PAY_ENROLLMENT_CREDIT"] = "FAIRE_PAY_ENROLLMENT_CREDIT";
        RetailerOfferName["LAST_CHANCE_FIRST_ORDER_INCENTIVE_V1"] = "LAST_CHANCE_FIRST_ORDER_INCENTIVE_V1";
        RetailerOfferName["PERSONALIZED_LAST_CHANCE_FIRST_ORDER_INCENTIVE_V1"] = "PERSONALIZED_LAST_CHANCE_FIRST_ORDER_INCENTIVE_V1";
        RetailerOfferName["EMAIL_VERIFICATION_FOR_TERMS_PRE_FCO"] = "EMAIL_VERIFICATION_FOR_TERMS_PRE_FCO";
        RetailerOfferName["EMAIL_VERIFICATION_FOR_TERMS_POST_FCO"] = "EMAIL_VERIFICATION_FOR_TERMS_POST_FCO";
        /**
     * Reward for pre-enrolling Faire Pay
     */ RetailerOfferName["FAIRE_PAY_ONE_TIME_DISCOUNT"] = "FAIRE_PAY_ONE_TIME_DISCOUNT";
        /**
     * Free period of Insider given as a retention offer to cancelling Retailers
     */ RetailerOfferName["INSIDER_RETENTION_OFFER"] = "INSIDER_RETENTION_OFFER";
        RetailerOfferName["SIGNUP_EMAIL_VERIFICATION_FOR_TERMS"] = "SIGNUP_EMAIL_VERIFICATION_FOR_TERMS";
        /**
     * Promotional pricing for annually billed Insider membership fees
     */ RetailerOfferName["INSIDER_SIGNUP_INCENTIVE_ANNUAL"] = "INSIDER_SIGNUP_INCENTIVE_ANNUAL";
        /**
     * Promotional pricing for monthly billed Insider membership fees when retailers are eligible for annual billing
     */ RetailerOfferName["INSIDER_SIGNUP_INCENTIVE_MONTHLY"] = "INSIDER_SIGNUP_INCENTIVE_MONTHLY";
        RetailerOfferName["PERSONALIZED_FIRST_ORDER_INCENTIVE_V2_LAST_CHANCE"] = "PERSONALIZED_FIRST_ORDER_INCENTIVE_V2_LAST_CHANCE";
    })(IOffer.RetailerOfferName || (IOffer.RetailerOfferName = {}));
    (function(State) {
        State["ELIGIBLE"] = "ELIGIBLE";
        State["APPLIED"] = "APPLIED";
        State["EXPIRED"] = "EXPIRED";
        State["REVOKED"] = "REVOKED";
    })(IOffer.State || (IOffer.State = {}));
    (function(DiscountBenefitLevel) {
        DiscountBenefitLevel["DISCOUNT_BENEFIT_LEVEL_UNKNOWN"] = "DISCOUNT_BENEFIT_LEVEL_UNKNOWN";
        DiscountBenefitLevel["ORDER"] = "ORDER";
        DiscountBenefitLevel["BRAND_ORDER"] = "BRAND_ORDER";
    })(IOffer.DiscountBenefitLevel || (IOffer.DiscountBenefitLevel = {}));
    (function(Source) {
        Source["SOURCE_UNKNOWN"] = "SOURCE_UNKNOWN";
        Source["BATCH_INCENTIVE_SYSTEM"] = "BATCH_INCENTIVE_SYSTEM";
        Source["FIRST_ORDER_CANCELLATION"] = "FIRST_ORDER_CANCELLATION";
        Source["FAIRE_DIRECT_SIGN_UP"] = "FAIRE_DIRECT_SIGN_UP";
        Source["FAIRE_OFFER"] = "FAIRE_OFFER";
        Source["NON_FAIRE_DIRECT_SIGN_UP"] = "NON_FAIRE_DIRECT_SIGN_UP";
        Source["ADMIN_GRANTED"] = "ADMIN_GRANTED";
        Source["FOI_S3_BASED_BACKFILL"] = "FOI_S3_BASED_BACKFILL";
        Source["FAIRE_DIRECT_RETAILER_FOI_ORDER_CANCELLATION"] = "FAIRE_DIRECT_RETAILER_FOI_ORDER_CANCELLATION";
    })(IOffer.Source || (IOffer.Source = {}));
    (function(OfferCondition) {
        OfferCondition["OFFER_CONDITION_UNKNOWN"] = "OFFER_CONDITION_UNKNOWN";
        OfferCondition["LINK_PLAID_ACH"] = "LINK_PLAID_ACH";
        OfferCondition["VERIFY_RETAILER_EMAIL"] = "VERIFY_RETAILER_EMAIL";
    })(IOffer.OfferCondition || (IOffer.OfferCondition = {}));
    (function(IBrandDiscountBenefit) {
        IBrandDiscountBenefit.build = function(partial) {
            return _object_spread({
                excluded_brands: []
            }, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IOffer.IBrandDiscountBenefit || (IOffer.IBrandDiscountBenefit = {}));
    IOffer.build = function(partial) {
        return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
    };
})(IOffer || (IOffer = {}));
export var IOffer;
